<template>
  <div class="w-100 bg-light-page">
    <HotelTopNavbar page="cart" />
    <block :height="83" />
    <span
      id="cart-top-section"
      class="position-absolute"
      style="top: 0 !important"></span>
    <div class="ga-container fluid d-block pb-5">
      <div class="row">
        <div class="col-xl-8 col-lg-7 col-md-12 order-lg-1 order-2">
          <div v-if="!$is_mobile_view" class="my-4">
            <HotelCheckoutStepper :steps="steps" :current-step="currentStep" />
          </div>
          <template v-if="viewType === 'FORM'">
            <!-- CONTACT DETAIL -->
            <div
              class="w-100 bg-white box-shadow-main rounded-6 border p-4 mb-5">
              <p class="mb-4 heading-6-1">Fill in data</p>
              <ContactDetail
                ref="contactDetail"
                :disabledForm="pushStatus.isLoad" />
              <div class="w-100 pt-4 mt-4 border-t-form-2-dashed">
                <label class="body-2 mb-1 d-block">Special request</label>
                <textarea
                  :disabled="pushStatus.isLoad"
                  @input="setConciergeTrxGeneralNotes(notes)"
                  class="p-3 body-2-1 w-100 border-form radius-6 w-100"
                  rows="2"
                  v-model="notes"></textarea>
              </div>
            </div>

            <!-- PAYMENT METHOD -->
            <span id="cart-payment"></span>
            <div class="w-100 bg-white box-shadow-main rounded-6 border p-4 mb-5" :class="{'border-danger' : $v.paymentOption.selected.$error}">
              <div class="w-100 mb-4">
                <p class="mb-0 heading-6-1">{{ paymentSectionHeader.title }}</p>
                <p class="mb-0 body-2">{{ paymentSectionHeader.subtitle }}</p>
                <p v-if="$v.paymentOption.selected.$error" class="body-2 text-danger">Please select payment option</p>
              </div>
              <div class="w-100">
                <div class="row">
                  <div class="col-12 col-md-6 mb-3 mb-md-0" v-for="po in paymentOption.options">
                    <div 
                      @click="selectPaymentOption(po)" 
                      class="w-100 radius-8 border-form p-3 d-flex align-items-top justify-content-between h-100 bg-green-alpha-hover border-green-alpha-hover cursor-pointer"
                      :class="{
                        'bg-green-alpha': po.id === paymentOption.selected
                      }"
                      >
                      <div>
                        <p class="mb-1 body-1-4">{{ po.name }}</p>
                        <p class="mb-0 body-2-2-1">{{ po.description }}</p>
                      </div>
                      <div class="pl-3">
                        <svg v-if="po.id !== paymentOption.selected" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z" fill="#777"/>
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" fill="var(--merchant-primary-color)"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-if="showPaymentMethod" class="w-100 mt-4 pt-4 border-t-form">
                <p class="mb-3 body-1-4">Select payment method</p>
                <PaymentMethod
                  ref="paymentMethod"
                  module="booking-engine"
                  @selectPayment="selectPaymentMethod"
                  :disabledForm="pushStatus.isLoad" />
              </div>
            </div>

            <div v-if="pushStatus.error != ''" class="w-100 text-left mb-4">
              <ErrorMessage :message="pushStatus.error" />
            </div>

            <state-button
              variant="secondary"
              size="lg"
              :click="submitForm"
              :block="$is_mobile_view">
              {{ showPaymentMethod ? 'Pay Now' : 'Book Now' }}
            </state-button>
          </template>

          <div
            v-if="viewType === 'PAYMENT'"
            class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
            <XenditInputCC
              :tx_payment="pushResult.payment"
              module_page="BOOKING_ENGINE"
              submodule_page="BE_ADDITIONAL_SERVICE"
              @done="resetSavedData"
              @expired="goToSearchPage">
            </XenditInputCC>
          </div>
        </div>

        <div
          class="col-xl-4 col-lg-5 col-md-12 order-lg-2 order-1 mb-lg-0 mb-5">
          <div class="general-booking-summary">
            <div v-if="$is_mobile_view" class="mb-4">
              <HotelCheckoutStepper
                :steps="steps"
                :current-step="currentStep" />
            </div>
            <CartPreview
              :paymentSurcharge="paymentSurcharge"
              :disabledForm="pushStatus.isLoad" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import { post, get } from '@/services/index.js';

import ContactDetail from '../../../components/hotel/be/additionalService/ContactDetail.vue';
import CartPreview from '../../../components/hotel/be/additionalService/CartPreview.vue';
import PaymentMethod from '../../../components/general/payment/PaymentMethod.vue';
import XenditInputCC from '@/components/hotel/be/XenditInputCC';
import HotelTopNavbar from '../../../components/hotel/HotelTopNavbar.vue';
import HotelCheckoutStepper from '../../../components/hotel/be/HotelCheckoutStepper.vue';
import { validationMixin } from "vuelidate";
const { required } = require("vuelidate/lib/validators");

export default {
  components: {
    HotelTopNavbar,
    ContactDetail,
    CartPreview,
    PaymentMethod,
    XenditInputCC,
    HotelCheckoutStepper,
  },
  data() {
    return {
      steps: [
        { order: 1, title: 'Your Selection' },
        { order: 2, title: 'Your Details' },
        { order: 3, title: 'Final Step' },
      ],
      viewType: 'FORM', // ["FORM", "PAYMENT"]
      currentStep: 2,
      windowWidth: window.innerWidth,
      notes: '',
      paymentMethod: {},
      pushStatus: {
        isLoad: false,
        error: '',
      },
      pushResult: {
        inquiry: {},
        payment: {},
      },
      moduleData: [],
      paymentOption: {
        options: [
          {id: 'PAY_LATER', name: 'Pay at the Hotel', description: 'Enjoy the convenience of paying at the hotel or after your service'},
          {id: 'PAY_IMMEDIATELY', name: 'Pay Now', description: 'Choose your payment method and complete booking instantly.'}
        ],
        selected: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getConciergeTrxGeneral',
      'getActivityTrxProducts',
      'getOutletTrxProducts',
      'getVoucherOrder',
      'getActivityTrxTotal',
      'getOutletTrxTotal',
      'getVoucherOrderTotal',
      'getActivityTrxProducts',
      'getOutletTrxProducts',
      'getVoucherOrder',
    ]),
    totalPrice() {
      return (
        Number(this.getActivityTrxTotal) +
        Number(this.getOutletTrxTotal) +
        Number(this.getVoucherOrderTotal)
      );
    },
    paymentSurcharge() {
      if (this.$isEmpty(this.paymentMethod)) return 0;
      const { surcharge_type, surcharge_value } = this.paymentMethod;
      return surcharge_type == 'PERCENT'
        ? (this.totalPrice / 100) * surcharge_value
        : surcharge_value;
    },
    moduleList(){
      let modules = [];

      const setModule = (merchantPos) => {
        const selectedMerchantPos = merchantPos.find(pos => pos.is_active);
        if(!selectedMerchantPos) return;

        const isModuleAlreadyInList = modules.some(mdl => mdl.id === selectedMerchantPos.id);
        if(!isModuleAlreadyInList) modules.push(selectedMerchantPos);
      }
      
      this.getActivityTrxProducts.forEach(product => {
        const { product_merchant_pos } = product.original_data;
        setModule(product_merchant_pos);
      })

      this.getOutletTrxProducts.forEach(product => {
        const { product_merchant_pos } = product.product_data;
        setModule(product_merchant_pos);
      })

      // this.getVoucherOrder.cart.forEach(voucher_parent => {
      //   voucher_parent.product.forEach(voucher=>{
      //     const { product_merchant_pos } = voucher.data;
      //     setModule(product_merchant_pos);
      //   })
        
      // })
      
      return modules;
    },
    paymentMode(){
      if(this.$isEmpty(this.moduleData)) return "PAY_IMMEDIATELY";

      const isSomeImmediately = this.moduleData.some(pos => pos.payment_mode === 'PAY_IMMEDIATELY');
      if(isSomeImmediately) return "PAY_IMMEDIATELY"; 
      
      const isSomeLater = this.moduleData.some(pos => pos.payment_mode === 'PAY_LATER');
      if(isSomeLater) return "PAY_LATER"; 
      
      return "PAY_IMMEDIATELY_OR_LATER";
    },
    paymentSectionHeader(){
      let text = {
        title: "Flexible Payment Methods",
        subtitle: "Decide whether to pay immediately or after your service."
      };

      const setText = (title, subtitle) => text = {title, subtitle}
      
      if(this.paymentMode === 'PAY_IMMEDIATELY') {
        setText("Confirm with Payment", "Select your preferred payment method and secure your service instantly");
      } else if(this.paymentMode === 'PAY_LATER'){
        setText("Reserve Now, Pay Later", "Enjoy the convenience of paying at the hotel or after your service.");
      } 
      
      return text;
    },
    showPaymentMethod(){
      const isPaymentImmediately = this.paymentMode === 'PAY_IMMEDIATELY';
      const isPaymentImmediatelyChoosen = this.paymentMode === 'PAY_IMMEDIATELY_OR_LATER' && this.paymentOption.selected === 'PAY_IMMEDIATELY';
      
      return isPaymentImmediately || isPaymentImmediatelyChoosen;
    }
  },
  mixins: [validationMixin],
  validations:{
    paymentOption:{
      selected:{
        required
      }
    }
  },
  watch: {
    totalPrice() {
      if (this.totalPrice === 0) {
        this.$router.push(`/${this.getMerchant.code}/booking`);
      }
    },
  },
  mounted() {
    if (this.totalPrice === 0) {
      this.$router.push(`/${this.getMerchant.code}/booking`);
    } else {
      this.$smoothScroll('cart-top-section');
      this.getNoteDataFromVuex();
      this.getGeneralConfig();
    }
  },
  methods: {
    ...mapMutations([
      'setConciergeTrxGeneralNotes',
      'resetAllDataConcierge',
      'resetAllDataMarketing',
    ]),
    goToPage(page) {
      this.$router.push({
        name: page,
        params: {
          merchant_code: this.getMerchant.code,
        },
      });
    },
    getNoteDataFromVuex() {
      this.notes = this.getConciergeTrxGeneral.notes;
    },
    selectPaymentMethod(paymentMethod) {
      this.paymentMethod = paymentMethod;
    },
    async getGeneralConfig(){
      const responses = await Promise.all(
        this.moduleList.map(mdl => this.fetchGeneralConfig(mdl.id))
      )

      responses.forEach(response => {
        if (this.$isNotEmptyV2(response)) {
          this.moduleData.push(response)
        }
      })
    },
    async fetchGeneralConfig(merchantPosId) {
      try {
        const apiResponse = await get(
          'CORE_HOTEL',
          `merchant-pos/${merchantPosId}/general`,
          { merchant_id: this.getMerchant.id }
        );

        const { success, data = null, message = '' } = apiResponse.data;
        if (!success) throw new Error(message);
        return data;
      } catch (error) {
        console.log("ERROR fetchGeneralConfig : ", error.message);
        return null;
      }
    },
    selectPaymentOption(paymentOption){
      this.paymentOption.selected = paymentOption.id
    },

    async validateForm() {
      try {
        const isContactValid = this.$refs.contactDetail.validateForm();
        if (!isContactValid) {
          this.$smoothScroll('cart-top-section');
          return false;
        }

        if(this.paymentMode === 'PAY_IMMEDIATELY_OR_LATER'){
          this.$v.$reset();
          this.$v.$touch();
          if(this.$v.$invalid) return false
        }

        if(this.showPaymentMethod) await this.$refs.paymentMethod.validateForm();
        return true;
      } catch (error) {
        if (error === 'PAYMENT') {
          this.$smoothScroll('cart-payment');
          return false;
        }
        throw error;
      }
    },

    formatProductListParams() {
      try {
        let productPerPos = [];

        const addProductPerPos = (
          merchant_pos_id,
          product,
          otherProductData = {}
        ) => {
          const { id, qty, notes } = product;

          const productPerPosIndex = productPerPos.findIndex(
            (pos) => pos.merchant_pos_id === merchant_pos_id
          );
          if (productPerPosIndex === -1) {
            productPerPos.push({
              merchant_pos_id,
              products: [{ id, qty, notes, ...otherProductData }],
            });
          } else {
            productPerPos[productPerPosIndex].products.push({
              id,
              qty,
              notes,
              ...otherProductData,
            });
          }
        };

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach((product, index) => {
          const {
            qty,
            notes = '',
            therapist_gender,
            place_choice,
            service_date,
            service_time,
            original_data: {
              product_merchant_pos,
              product_ga_pos_id,
              use_schedule,
            },
          } = product;

          let otherProductData = {
            therapist_gender,
            place_choice,
            service_date: moment(service_date).format('YYYY-MM-DD'),
            schedule_id: use_schedule ? service_time.id : null,
          };

          otherProductData.service_date += use_schedule
            ? ' 00:00'
            : ` ${moment(service_time.schedule_start, 'HH:mm:ss').format(
                'HH:mm'
              )}`;

          addProductPerPos(
            product_merchant_pos[0].id,
            { id: product_ga_pos_id, qty, notes },
            otherProductData
          );
        });

        // OUTLET
        this.getOutletTrxProducts.forEach((product, index) => {
          const isProductVariant = product.variants.length > 0;
          if (isProductVariant) {
            const {
              product_data: { product_pos },
              variants,
            } = product;
            variants.forEach((variant) => {
              const {
                qty,
                notes,
                variant_data: { product_ga_pos_id },
              } = variant;
              addProductPerPos(product_pos[0].id, {
                id: product_ga_pos_id,
                qty,
                notes,
              });
            });
          } else {
            const {
              qty,
              notes,
              product_data: { product_merchant_pos, product_ga_pos_id },
            } = product;
            addProductPerPos(product_merchant_pos[0].id, {
              id: product_ga_pos_id,
              qty,
              notes,
            });
          }
        });

        // VOUCHER
        this.getVoucherOrder.cart.forEach((voucher) => {
          const { pos, product } = voucher;
          product.forEach((productItem) => {
            const {
              variant_list: variants,
              is_variant: isVariant,
              qty,
              notes,
              data,
            } = productItem;

            if (isVariant) {
              variants.forEach((variant) => {
                const {
                  qty: variantQty,
                  notes: variantNotes,
                  data: { product_ga_pos_id },
                } = variant;
                addProductPerPos(pos.id, {
                  id: product_ga_pos_id,
                  qty: variantQty,
                  notes: variantNotes,
                });
              });
            } else {
              addProductPerPos(pos.id, {
                id: data.product_ga_pos_id,
                qty,
                notes,
              });
            }
          });
        });

        return productPerPos;
      } catch (error) {
        throw error;
      }
    },
    getInquiryParams() {
      try {
        const unnecessaryParam = {
          room_id: '',
          region: '',
          promo_code: '',
          campaign_id: '',
          guest_journey_id: '',
        };

        const paymentMode = () => {
          if(this.paymentMode !== 'PAY_IMMEDIATELY_OR_LATER') return this.paymentMode
          return this.paymentOption.selected;
        }

        return {
          merchant_id: this.getMerchant.id,
          customer_detail: this.getConciergeTrxGeneral.contactDetails,
          notes: this.notes,
          device: this.$getDeviceType(),
          payment_mode: paymentMode(),
          tx_merchant_pos: this.formatProductListParams(),
          source: 'BOOKING_ENGINE',
          ...unnecessaryParam,
        };
      } catch (error) {
        throw error;
      }
    },
    async pushInquiry() {
      try {
        const apiParams = this.getInquiryParams();
        const apiResponse = await post(
          'CORE_HOTEL',
          'merchant-pos/multiple/tx-inquiry',
          apiParams
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);
        this.pushResult.inquiry = data;
      } catch (error) {
        throw error;
      }
    },

    getPaymentParams() {
      try {
        const { first_name, last_name, email, phone_number } = this.getConciergeTrxGeneral.contactDetails;

        const { id: inquiryId, total_payment } = this.pushResult.inquiry;
        let totalAmount = Number(total_payment) + Number(this.paymentSurcharge);

        const {
          id: paymentMethodId,
          payment_method,
          bank_name,
          payment_channel,
        } = this.paymentMethod;

        return {
          merchant_id: this.getMerchant.id,
          tx_order_invoice_id: inquiryId,
          amount: Number(totalAmount.toFixed(2)),
          customer_detail: {
            name: first_name,
            last_name: this.$isNotEmptyV2(last_name) ? last_name : '',
            email,
            phone_number,
          },
          payment_details: {
            id: paymentMethodId,
            payment_method,
            bank_name,
            payment_channel,
          },
        };
      } catch (error) {
        throw error;
      }
    },
    async pushPayment() {
      try {
        const apiParams = this.getPaymentParams();
        const apiResponse = await post(
          'CORE_HOTEL',
          'merchant-pos/tx-payment',
          apiParams
        );
        const { success, payment, message, tx_order_id } = apiResponse.data;
        if (!success) throw new Error(message);
        this.pushResult.payment = payment;

        const { bank_name, payment_method } = this.paymentMethod;
        const isPaymentXenditCreditCard =
          bank_name === 'XENDIT' && payment_method === 'CREDIT_CARD';

        if (isPaymentXenditCreditCard) {
          this.pushResult.payment.tx_order_id_2 = tx_order_id;
          this.viewType = 'PAYMENT';
        } else {
          this.$proceedPayment(
            'BE_ADDITIONAL_SERVICE',
            this.pushResult.inquiry,
            apiResponse.data,
            this.paymentMethod
          );
        }
      } catch (error) {
        throw error;
      }
    },

    async submitForm() {
      try {
        const isAllDataValid = await this.validateForm();
        if (!isAllDataValid) return;

        this.pushStatus = {
          isLoad: true,
          error: '',
        };

        await this.pushInquiry();
        
        if(this.showPaymentMethod) await this.pushPayment();
        else this.resetSavedData()

      } catch (error) {
        this.pushStatus.error = error;
      } finally {
        this.pushStatus.isLoad = false;
        Promise.resolve();
      }
    },

    resetSavedData() {
      this.resetAllDataConcierge();
      this.resetAllDataMarketing();
      this.$router.push({
        name: 'BePaymentResult',
        params: {
          tx_order_id: this.pushResult.inquiry.id,
        },
        query: {
          module: 'additional-service',
        },
      });
    },
    goToSearchPage() {
      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartAdditional.vue